"use strict";

/**
 * Esegue la callback al DOM ready (navigazione classica, senza SPA / Swup).
 */
function onReady(cb) {
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", cb, { once: true });
    } else {
        cb();
    }
}

export { onReady };
